import axios, { AxiosPromise } from 'axios';

export interface UbicacionBusqueda {
    /** `href` de la pantalla del menú donde está el registro. */
    pantalla: string;
    href: string;
    label: string;
    detalle?: string;
}

export interface ConceptoBusqueda {
    tipo: 'OP' | 'Guía' | 'Hardware' | 'Cliente';
    codigo: string;
    detalle: string;
    ubicaciones: UbicacionBusqueda[];
}

/** Dónde aparece un código (OP, guía, código ISO o hostname, cliente) en el ERP. */
export function buscarDondeAparece(q: string): AxiosPromise<ConceptoBusqueda[]> {
    return axios.get('api/busqueda', { params: { q } });
}
